@if (itinerary?.inclusions?.length || itinerary?.exclusions?.length) {
    <section
        class="scroll-mt-96 space-y-8 px-4 md:scroll-mt-32 md:px-8 xl:p-0"
        appTripsItinerarySection
        title="Inclusions">
        <h2 class="pb-8 text-center tracking-wide">Inclusions</h2>
        <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div>
                <h3 class="pb-8 font-semibold tracking-wide">Price Includes</h3>
                <div class="">
                    @for (
                        inclusion of itinerary?.inclusions.slice(
                            0,
                            noOfInclusionsDisplayed
                        );
                        track inclusion
                    ) {
                        <app-trips-itinerary-inclusion-item
                            class="md:pb-8 md:pr-12"
                            [inclusion]="
                                inclusion
                            "></app-trips-itinerary-inclusion-item>
                    }
                </div>
                @if (
                    itinerary?.inclusions.length >
                    defaultNoOfInclusionsDisplayed
                ) {
                    <button
                        class="ml-6 p-0 text-left font-medium text-red"
                        (click)="
                            toggleInclusionsDisplayed(itinerary?.inclusions)
                        ">
                        See
                        {{
                            noOfInclusionsDisplayed ===
                            defaultNoOfInclusionsDisplayed
                                ? 'all'
                                : 'fewer'
                        }}
                        inclusions
                    </button>
                }
            </div>
            <div>
                <h3 class="pb-8 font-semibold tracking-wide">
                    Price Does Not Include
                </h3>
                <div class="">
                    @for (
                        exclusion of itinerary?.exclusions.slice(
                            0,
                            noOfExclusionsDisplayed
                        );
                        track exclusion
                    ) {
                        <app-trips-itinerary-exclusion-item
                            class="md:pb-8 md:pr-12"
                            [exclusion]="
                                exclusion
                            "></app-trips-itinerary-exclusion-item>
                    }
                </div>
                @if (
                    itinerary?.exclusions.length >
                    defaultNoOfExclusionsDisplayed
                ) {
                    <button
                        class="ml-6 p-0 text-left font-medium text-red"
                        (click)="
                            toggleExclusionsDisplayed(itinerary?.exclusions)
                        ">
                        See
                        {{
                            noOfExclusionsDisplayed ===
                            defaultNoOfExclusionsDisplayed
                                ? 'all'
                                : 'fewer'
                        }}
                        exclusions
                    </button>
                }
            </div>
        </div>
    </section>
}
